import { useEffect } from "react";
import { useLocation, useNavigation } from "react-router-dom";
import { SessionStorageKeys } from "@/common/browserStorage/constants";

export function useSafePendingUrl() {
  const location = useLocation();
  const navigation = useNavigation();

  useEffect(() => {
    if (navigation.location) {
      const url =
        navigation.location.pathname +
        navigation.location.search +
        navigation.location.hash;
      sessionStorage.setItem(SessionStorageKeys.PendingUrl, url);
    }
  }, [navigation.location, location]);
}
